module.exports = __webpack_public_path__ + "static/img/bcg_f.51f3e859.png";